/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css"
/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css"
import "@ionic/react/css/structure.css"
import "@ionic/react/css/typography.css"
/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css"
import "@ionic/react/css/float-elements.css"
import "@ionic/react/css/text-alignment.css"
import "@ionic/react/css/text-transformation.css"
import "@ionic/react/css/flex-utils.css"
import "@ionic/react/css/display.css"

/* Theme variables */
import "./theme/variables.css"

import jwt_decode from "jwt-decode"
import React, {useEffect} from "react"
import { useDispatch, useSelector } from "react-redux"
import {Route, Routes} from "react-router-dom"
import { BrowserRouter } from "react-router-dom"

import Footer from "./components/Footer/Index"
import Header from "./components/Header/Index"
import AccountContact from "./pages/AccountContact/Index"
import AccountNotifications from "./pages/AccountNotifications/Index"
import AccountUpdatePaymentMethod from "./pages/AccountUpdatePaymentMethod/Index"
import AccountProfile from "./pages/AccountProfile/Index"
import AuctionItemsPage from "./pages/AuctionItems/Index"
import Checkout from "./pages/Checkout/Index"
import CreateAccountPage from "./pages/CreateAccount/Index"
import EventPage from "./pages/Event/Index"
import ItemDetailsPage from "./pages/ItemDetails/Index"
import CartPage from "./pages/CartPage/Index"
import LoginPage from "./pages/Login/Index"
import MyAccount from "./pages/MyAccount/Index"
import MyOrders from "./pages/MyOrders/Index"
import NotFound from "./pages/NotFound/NotFound"
import OpenBids from "./pages/OpenBids/Index"
import PlaceBid from "./pages/PlaceBid/Index"
import AutoBid from "./pages/AutoBid/Index";
import PrivacyPolicy from "./pages/PrivacyPolicy/Index"
import ResetPassword from "./pages/ResetPassword/Index"
import ResetPasswordVerification from "./pages/ResetPasswordVerification/Index"
import ResetPasswordAccount from "./pages/ResetPasswordAccount/Index"
import ResetPasswordEmail from "./pages/ResetPasswordEmail/Index"
import SetupAccount from "./pages/SetupAccount/Index"
import VerificationPage from "./pages/Verification/Index"
import VerifyAccount from "./pages/VerifyAccount/Index"
import WelcomePage from "./pages/Welcome/Index"
import {
  fetchAuctionItemsData,
  updateAuctionItems
} from "./redux/slices/auctionItemsSlice"
import {fetchEventData, setAuctionCode, setEventCode} from "./redux/slices/eventSlice"
import {fetchPrivacyPolicy, setPrivacyAuctionCode, setPrivacyEventCode} from "./redux/slices/privacyPolicySlice"
import {checkTokenOnRefresh, updateUserInfo} from "./redux/slices/userSlice"
import {resetNotification} from "./redux/slices/notificationSlice";
import {
    AUCTION_ITEMS_ENDPOINT,
    PRIVACY_POLICY,
    USER_PROFILE,
    getEndPoint, CART_ENDPOINT
} from "./util/api/enpoints"
import { getURL } from "../src/constants"
import {ReactNotifications, Store as notificationStore} from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

import {
    IonContent,
    IonToast,
    IonApp,
} from "@ionic/react";
import { setupIonicReact } from '@ionic/react';
import store from "./redux/store";
import SlideshowPage from "./pages/Slideshow/Index";
import useResetEvent from "./hooks/useResetEvent";
import useOgMeta from "./hooks/useOgMeta";
import Store from "./pages/Store/Index";
import Purchaser from "./pages/Purchaser/Index";


import {library} from '@fortawesome/fontawesome-svg-core';
import * as Icons from '@fortawesome/free-solid-svg-icons';
import StripeCheckout from "./pages/StripeCheckout/Index";
import GuestRegistration from "./pages/GuestRegistration/Index";

const iconList = Object.keys(Icons)
    .filter((key) => key !== 'fas' && key !== 'prefix')
    .map((icon) => Icons[icon]);

library.add(...iconList);

const App: React.FC = (props: any) => {
    useResetEvent()
    useEffect(() => {
        window.addEventListener("offline", processOfflineNotification, false)
        window.addEventListener("online", processOnlineNotification, false)

        return () => {
            window.removeEventListener("offline", processOfflineNotification)
            window.removeEventListener("online", processOnlineNotification)
        }
    }, [])

    const processOfflineNotification = () => {
        notificationStore.addNotification({
            title:  "We're having trouble connecting to the internet",
            // message: parsedData.message,
            type: "danger",
            insert: "bottom",
            container: "bottom-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            width: 400,
            touchSlidingExit: {
                swipe: {
                    duration: 400,
                    timingFunction: 'ease-out',
                    delay: 0,
                },
                fade: {
                    duration: 400,
                    timingFunction: 'ease-out',
                    delay: 0
                }
            },
            dismiss: {
                duration: 0,
                showIcon: true,
                click: true,
                touch: true
            }
        });
    }

    const processOnlineNotification = () => {
        notificationStore.removeAllNotifications()
    }


    const dispatch = useDispatch()
    // const isLoggedIn = useSelector((state: any) => state.user.isLoggedIn)
    const eventcode = useSelector((state: any) => state.user.eventcode)
    const auctioncode = useSelector((state: any) => state.user.auctioncode)
    const notification = useSelector((state: any) => state.notification)
    const eventName = useSelector((state: any) => state.event.eventname)
    const eventLogoUrl = useSelector((state: any) => state.event.logourl)

    const pathSegments = window.location.pathname.split('/')
    const isStorePage = pathSegments[2]?.toLowerCase() === 'event'
    useOgMeta(isStorePage ? undefined : eventName, isStorePage ? undefined : eventLogoUrl)

    useEffect(() => {
        const pathEventcode = pathSegments[1]
        if (!pathEventcode || isStorePage || localStorage.getItem("token")) {
            return
        }
        if (store.getState().event.status === 'idle') {
            dispatch(fetchEventData({
                url: getEndPoint('EVENT_ENDPOINT'),
                eventcode: pathEventcode,
                auctioncode: window.location.hostname.split('.')[0]
            }))
        }
    }, [])
    // const eventcode = useSelector((state: any) => state.event.eventcode)


    const auctionItemsFetchState = useSelector(
    (state: any) => state.auctionItems.status
    )

    let token = localStorage.getItem("token")

  useEffect(() => {

    const validateToken = async () => {
      console.log('validate token')
      /**
       * add the end point to the server side for the same
       * dispacth login actions accordingly
       */

      // console.log(token)

      if (token && token !== "undefined") {
        // CAN I USE A PATTERN MATCH HERE????
        // const regex = /\/events\/[0-9a-zA-Z*]/g;
        // const found = window.location.pathname.match(regex);
        // console.log(Router.map)
        const decoded: any = jwt_decode(token)
        var current_time = Date.now() / 1000;
        console.log(current_time)
        console.log(decoded.exp)
        if (decoded.exp < current_time) {
          // expired
          console.log('expired token')
          localStorage.removeItem("token")
        }
        else {
            const response: any = await dispatch(
                checkTokenOnRefresh({ url: getEndPoint(USER_PROFILE) })
            )
            console.log(response)
            if (response.error) {
                localStorage.removeItem("token")
                console.log(response.error)
            } else if (response.payload) {
                if (decoded.isguest === '1') {
                    dispatch(
                        updateUserInfo({
                            accountstatus: 'guest',
                            firstname: 'Guest',
                            authorizebidder: false,
                            isLoggedIn: true
                        })
                    )
                }
                console.log(decoded)
                if (decoded.eventcode) {
                    // Test to make sure we are the same event else logout
                    if (!window.location.pathname.includes(decoded.eventcode)) {
                        localStorage.removeItem("token")
                    }
                    else {
                        const url = getEndPoint('EVENT_ENDPOINT')
                        const eventData = {
                            url,
                            eventcode: decoded.eventcode,
                            auctioncode: decoded.auctioncode
                        }
                        dispatch(fetchEventData(eventData))
                        dispatch(setEventCode(decoded.eventcode))
                        dispatch(setAuctionCode(decoded.auctioncode))
                        dispatch(setPrivacyEventCode(decoded.eventcode))
                        dispatch(setPrivacyAuctionCode(decoded.auctioncode))
                        // Get auction items due to the "My Orders" needing this data. So if auction items are not
                        // displayed before clicking on "My Orders"
                        if (auctionItemsFetchState === "idle") {
                            dispatch(
                                fetchAuctionItemsData(getEndPoint(AUCTION_ITEMS_ENDPOINT))
                            )
                        }
                        if (auctionItemsFetchState === "succeeded") {
                            dispatch(updateAuctionItems())
                        }

                        dispatch({
                            type: "TOKEN_CONNECT",
                            payload: {
                                url: getURL(),
                                token: token
                            }
                        })
                    }
                }

            }
        }
        }
    }

    validateToken()
  }, [])

    setupIonicReact({
        mode: 'ios'
    });

    useEffect(() => {
        if (auctioncode && eventcode) {
            dispatch(fetchPrivacyPolicy({url: getEndPoint(PRIVACY_POLICY), eventcode: eventcode, auctioncode: auctioncode}))
        }

    }, [auctioncode, eventcode])

  return (
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <IonApp >
              <div className="app-container">
                  <ReactNotifications />
              </div>

              <IonToast
                    isOpen={notification.isOpen}
                    onDidDismiss={() => store.dispatch( resetNotification() )}
                    message={notification.message}
                    duration={notification.timeout}
                    buttons={notification.buttons}
                    cssClass={'custom-toast'}
              />
              <Header></Header>

              {/*<IonContent>*/}
                  <Routes>
                    {/*<Route exact={true} path="/:eventcode/home" component={Home} />*/}
                    <Route  path="/:eventcode/event" element={<IonContent style={{backgroundColor: 'transparent'}}><Store /></IonContent>} />
                    <Route  path="/:eventcode/event/:id/" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Store /></IonContent> } />
                    <Route  path="/:eventcode/event/:id/:cart" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Store /></IonContent> } />
                    <Route  path="/:eventcode/event/purchaserregistration/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Purchaser /></IonContent>} />
                    <Route  path="/:eventcode/event/guestregistration/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><GuestRegistration /></IonContent>} />
                    <Route  path="/:eventcode/not-found" element={<IonContent style={{backgroundColor: '#f2f2f2'}}>NotFound</IonContent>}></Route>
                    <Route  path="/:eventcode/verify-email" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><VerificationPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/contact-us" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountContact /></IonContent>}></Route>
                    <Route  path="/:eventcode/verify-email/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><VerificationPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/verify/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><VerifyAccount /></IonContent>}></Route>
                    <Route  path="/:eventcode/auth/passwordlessLogin/:loginguid" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><EventPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/login" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><LoginPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/login/" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><LoginPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/create-account" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><CreateAccountPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/setup-account" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SetupAccount /></IonContent>}></Route>
                    <Route  path="/:eventcode/reset-password" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ResetPassword /></IonContent>}></Route>
                    <Route  path="/:eventcode/auth/resetPassword/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ResetPasswordVerification /></IonContent>}></Route>
                    <Route  path="/:eventcode/reset-password-account" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ResetPasswordAccount /></IonContent>} />
                    <Route  path="/:eventcode/account-notifications" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountNotifications /></IonContent>}></Route>
                    <Route  path="/:eventcode/account-update-payment-method/auction-items/:itemid?" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountUpdatePaymentMethod /></IonContent>}></Route>
                    <Route  path="/:eventcode/account-update-payment-method/:id?" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountUpdatePaymentMethod /></IonContent>}></Route>
                    <Route  path="/:eventcode/account-update-payment-method/login/:login?" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountUpdatePaymentMethod /></IonContent>}></Route>
                    <Route  path="/:eventcode/account-profile" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AccountProfile /></IonContent>}></Route>
                    <Route  path="/:eventcode/privacy-policy" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><PrivacyPolicy /></IonContent>}></Route>
                    <Route  path="/:eventcode/reset-password-email" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ResetPasswordEmail /></IonContent>} />
                    <Route  path="/:eventcode/welcome" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><WelcomePage /></IonContent>}></Route>
                    <Route  path="/:eventcode/auction-items/:id/popupbuyitnow/:popup?" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ItemDetailsPage /></IonContent>}/>
                    <Route  path="/:eventcode/auction-items/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><ItemDetailsPage /></IonContent>}/>
                    <Route  path="/:eventcode/auction-items" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AuctionItemsPage /></IonContent>}/>
                    <Route  path="/:eventcode/place-bid/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><PlaceBid /></IonContent>}/>
                    <Route  path="/:eventcode/auto-bid/:id" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><AutoBid /></IonContent>}/>
                    <Route  path="/:eventcode/my-orders" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><MyOrders /></IonContent>}></Route>
                    <Route  path="/:eventcode/my-account" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><MyAccount /></IonContent>}></Route>
                    <Route  path="/:eventcode/cart" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><CartPage /></IonContent>}></Route>
                    <Route  path="/:eventcode/open-bids" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><OpenBids /></IonContent>} />
                    <Route  path="/:eventcode/stripe" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><StripeCheckout /></IonContent>} />
                    <Route  path="/:eventcode/checkout" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Checkout /></IonContent>} />
                    <Route  path="/:eventcode/checkout/:orders" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Checkout /></IonContent>} />
                    <Route  path="/:eventcode/checkout-item/:historyid" element={<IonContent style={{backgroundColor: '#f2f2f2'}}><Checkout /></IonContent>}></Route>
                    <Route  path={"/:eventcode"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><EventPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/detail"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/detail/:location"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/detail/:location/:timeframe"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/list"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/list/:location"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/list/:location/:timeframe/:pagecount"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>
                    <Route  path={"/:eventcode/list/pc/:pagecount"} element={<IonContent style={{backgroundColor: '#f2f2f2'}}><SlideshowPage /></IonContent>}></Route>

                    {/*<Route  path="/" >*/}
                    {/*    /!*<Redirect to="https://donorsnap.com" />*!/*/}
                    {/*</Route>*/}
                      <Route  path="/" element={<IonContent>NotFound</IonContent>}></Route>


                    {/*<Route exact path="/:eventcode" component={EventPage}></Route>*/}
                    {/*<Route  path="/" component={HomeRedirect}></Route>*/}

                    {/*<div style={{ marginBottom: "20px", backgroundColor: '#f2f2f2', position: "relative", padding:"0 10px", textAlign: "center", fontSize: 14 }}>AuctionSnap All Rights Reserved by DonorSnap Review AuctionSnap{" "}*/}
                    {/*    <span style={{ color: "red" }}>*/}
                    {/*        <a><Link style={{ textDecoration: 'none' }} to="/event/privacy-policy">Privacy Policy</Link></a>*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                  </Routes>
              {/*</IonContent>*/}
              <Footer></Footer>
          </IonApp>
      </BrowserRouter>
  )
}
export default App
